
import React from 'react';
import { Button } from "@/components/ui/button";
import { Upload } from 'lucide-react';
import { Spinner } from "@/components/ui/Spinner";

interface PhotoFileUploadProps {
  onFileSelect: (file: File) => void;
  isLoading: boolean;
}

export const PhotoFileUpload = ({ onFileSelect, isLoading }: PhotoFileUploadProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <div className="space-y-4">
      <input
        type="file"
        accept="image/*"
        id="contact-photo-upload"
        onChange={handleFileChange}
        disabled={isLoading}
        className="hidden"
      />
      <label htmlFor="contact-photo-upload">
        <Button 
          variant="outline" 
          className="w-full cursor-pointer" 
          disabled={isLoading}
          asChild
        >
          <div>
            {isLoading ? (
              <>
                <Spinner size="sm" className="mr-2" ariaLabel="Uploading" />
                Uploading...
              </>
            ) : (
              <>
                <Upload className="mr-2 h-4 w-4" />
                Upload Photo
              </>
            )}
          </div>
        </Button>
      </label>
    </div>
  );
};
